import clsx from 'clsx';
import queryString from 'query-string';
import React, { useEffect, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from '../components/Swiper';
import { getPlacesAutocomplete, getTypeProperties } from '../api';
import AutoComplete from '../components/AutoComplete';
import Main from '../layouts/Main';
import authentic from '../images/home/Imagen 2.png';
import pawi from '../images/home/Imagen 3.png';
import lqn from '../images/home/Imagen 4.png';
import stella from '../images/home/stella-mccartney-1_trans_NvBQzQNjv4BqRijACm7ll7hIyJ_qd38LlxMS36CsBoA8kV08c2xN0aY.png';
import styles from './Home.module.scss';
import { getSearchObjectFromAutocomplete } from '../helpers/general';
import { Box, FormControl, InputBase, NativeSelect } from '@mui/material';
import { createStyles, withStyles, Theme } from '@material-ui/core/styles';

import Button from '../components/core/Button';
/* import { Link } from 'react-router-dom'; */

const BootstrapInput = withStyles((theme: Theme) =>
  createStyles({
    root: {
      'label + &': {
        marginTop: theme.spacing(0),
      },
    },
    input: {
      borderRadius: 7,
      backgroundColor: theme.palette.background.paper,
      border: '1px solid #bbb',
      fontSize: 14,
      [theme.breakpoints.up('md')]: {
        fontSize: 16,
      },
      padding: '14px 14px 14px 14px',
      transition: theme.transitions.create(['border-color', 'box-shadow']),
      color: '#312d2c',
      // Use the system font instead of the default Roboto font.
      fontFamily: 'Poppins',
      '&:focus': {
        borderRadius: 4,
        borderColor: '#bbb',
      },
    },
  })
)(InputBase);

const steps = [
  {
    title: (
      <>
        Todo el mercado <br />
        inmobiliario
      </>
    ),
    iconClass: clsx('fonticons', 'fonticons-search', styles.stepIcon),
    desc:
      'Hauscanner te encuentra el inmueble que buscas !Al mejor precio del mercado!. Contamos con toda la oferta inmobiliaria de Colombia!',
  },
  {
    title: (
      <>
        Todo lo que necesita
        <br /> saber antes de comprar
      </>
    ),
    iconClass: clsx('fonticons', 'fonticons-calendar', styles.stepIcon),
    desc:
      'Analizamos todas las plataformas de bienes raíces en tiempo real para ti!, sabrás cuál inmueble es un buen precio, generaras nuevas oportunidades de negocio y llevarás tus metas a un nuevo nivel!',
  },
  {
    title: (
      <>
        Notificación instantánea
        <br /> a tu teléfono
      </>
    ),
    iconClass: clsx('fonticons', 'fonticons-checked', styles.stepIcon),
    desc: (
      <>
        Filtra por el tipo de inmueble que deseas encontrar y recibirás
        notificaciones instantáneas en tu teléfono cada vez que tu tipo de
        propiedad se ponga en venta en toda Colombia¡ Somos tú asistente digital
        en tiempo real!
      </>
    ),
  },
  /* {
    title: (
      <>
        Paga y recibe
        <br /> tu propiedad
      </>
    ),
    iconClass: clsx('fonticons', 'fonticons-happy', styles.stepIcon),
    desc:
      'Realiza el pago de tu propiedad al dueño de la propiedad de forma segura por medio de nuestro sitio web, recibe tu propiedad, toda la documentación que te acredita como dueño y disfrútala!',
  }, */
];

export default function Home() {
  const searchTypeContainer = useRef<HTMLDivElement>(null);
  const [type, setType] = useState(['apartamento']);
  const [location, setLocation] = useState<any>(null);
  const [typesProperty, setTypesProperty] = useState<any>([]);
  const handleSearchItemClick = (item: any) => {
    const { searchStrKey, searchStrValue } = getSearchObjectFromAutocomplete(
      item
    );
    const filterParams: Record<string, any> = {
      [searchStrKey]: searchStrValue,
    };

    setLocation(filterParams);
  };

  const handleChange = (event: any) => {
    setType([event.target.value as string]);
  };

  const sendFilter = () => {
    let filter;
    if (location) {
      filter = JSON.stringify({
        [Object.keys(location)[0]]: location[Object.keys(location)[0]],
        'info.type': type,
      });
    } else {
      filter = JSON.stringify({
        'info.type': type,
      });
    }
    window.location.href = `/properties?${queryString.stringify({
      filters: filter,
    })}`;
  };

  useEffect(() => {
    getTypeProperties().then((response) => {
      setTypesProperty(response.data.data);
    });
  }, []);

  return (
    <Main>
      <div className={styles.container}>
        <div className={styles.search}>
          <div className={styles.searchContent}>
            <div className={styles.logo} />
            <h2>
              La propiedad que buscas <br /> al mejor precio del mercado
            </h2>

            <p style={{ display: 'none' }} className={styles.submessage}>
              <b>100% digital</b> con garantía de satisfacción
            </p>

            <div
              style={{ display: 'none' }}
              className={styles.checkType}
              ref={searchTypeContainer}
            >
              <label>
                <input type="checkbox" name="type" value="apartamento" />
                <span>Apto</span>
              </label>
              <label>
                <input type="checkbox" name="type" value="casa" />
                <span>Casa</span>
              </label>
              <label>
                <input type="checkbox" name="type" value="local" />
                <span>Local</span>
              </label>
              <label>
                <input type="checkbox" name="type" value="bodega" />
                <span>Bodega</span>
              </label>
            </div>
            <div className={styles.containerSearch}>
              <div className={styles.background}>
                <AutoComplete
                  apiFn={getPlacesAutocomplete}
                  resultsPath="data.data"
                  resultItemLabelPath="value"
                  onItemClick={handleSearchItemClick}
                  /*defaultItems={[
                  { field: 'city', value: 'Barranquilla', properties: '48' },
                  { field: 'name', value: 'Barrio el prado', properties: '1' },
                ]} */
                  inputProps={{
                    placeholder: 'Busca por ciudad, zona o barrio',
                  }}
                />
                <Box className={styles.box}>
                  <FormControl className={styles.formControl}>
                    <NativeSelect
                      id="demo-customized-select-native"
                      value={type}
                      onChange={handleChange}
                      input={<BootstrapInput />}
                    >
                      {typesProperty.map((item: any, index: any) => {
                        return (
                          <option key={index} value={item._id}>
                            {item._id} ({item.count})
                          </option>
                        );
                      })}
                    </NativeSelect>
                  </FormControl>
                </Box>
                <Button
                  onClick={() => sendFilter()}
                  className={styles.button}
                  label="Buscar"
                >
                  Buscar
                </Button>
              </div>
            </div>
            <div className={styles.containerSearchMobile}>
              <div className={styles.background}>
                <AutoComplete
                  apiFn={getPlacesAutocomplete}
                  resultsPath="data.data"
                  resultItemLabelPath="value"
                  onItemClick={handleSearchItemClick}
                  /* defaultItems={[
                  { field: 'city', value: 'Barranquilla', properties: '48' },
                  { field: 'name', value: 'Barrio el prado', properties: '1' },
                ]} */
                  inputProps={{
                    placeholder: 'Busca por ciudad, zona o barrio',
                  }}
                />
                <Box className={styles.box}>
                  <FormControl className={styles.formControl}>
                    <NativeSelect
                      id="demo-customized-select-native"
                      value={type}
                      onChange={handleChange}
                      input={<BootstrapInput />}
                    >
                      {typesProperty.map((item: any, index: any) => {
                        return (
                          <option key={index} value={item._id}>
                            {item._id} ({item.count})
                          </option>
                        );
                      })}
                    </NativeSelect>
                  </FormControl>
                </Box>
                <Button
                  onClick={() => sendFilter()}
                  className={styles.button}
                  label="Buscar"
                >
                  Buscar
                </Button>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.steps}>
          {steps.map((step, idx) => (
            <div key={idx} className={styles.step}>
              <span className={styles.stepNumber}>{idx + 1}</span>
              <i className={step.iconClass} />
              <h1>{step.title}</h1>
              <p>{step.desc}</p>
            </div>
          ))}
        </div>

        <div style={{ display: 'none' }} className={styles.testimonials}>
          <h2>Testimonios</h2>
          <Swiper
            id="main"
            className={styles.Carousel}
            tag="section"
            wrapperTag="ul"
            slidesPerView={2}
            initialSlide={1}
            centeredSlides={true}
            spaceBetween={20}
          >
            {[...Array(4)].map((_value, index) => (
              <SwiperSlide key={`slide-${index}`} tag="li">
                <div className={styles.testimonial}>
                  <h3>La mejor aplicacion!</h3>
                  <p>Luisa Restrepo</p>
                  <img src={stella} />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        <div className={styles.allies}>
          <h2>Aliados</h2>

          <Swiper
            id="main"
            className={styles.Carousel}
            tag="section"
            wrapperTag="ul"
            slidesPerView={3}
            spaceBetween={20}
            pagination={{ clickable: true, dynamicBullets: true }}
          >
            <SwiperSlide tag="li">
              <img src={authentic} />
            </SwiperSlide>
            <SwiperSlide tag="li">
              <img src={pawi} />
            </SwiperSlide>
            <SwiperSlide tag="li">
              <img src={lqn} />
            </SwiperSlide>
          </Swiper>
        </div>

        {/*         <div className={styles.footer}>
          <div className={styles.left}>
            <h1 className={styles.logo} />
          </div>
          <div className={styles.right}>
            <ul>
              <li>
                <a target="_blank" href="https://www.instagram.com/hauscanner">
                  <i className="fonticons fonticons-instagram" />
                </a>
              </li>
              <li>
                <a target="_blank" href="https://twitter.com/hauscanner">
                  <i className="fonticons fonticons-twitter" />
                </a>
              </li>
            </ul>
            <ul className={styles.bottomEls}>
              <li>
                <Link to="/data-politics">Habeas Data</Link>
              </li>
              <li>
                <Link to="/terms">Términos y condiciones</Link>
              </li>
              <li>
                <Link to="/cookies-politics">Política de privacidad</Link>
              </li>
              <li>
                <Link to="/faq">Preguntas frecuentes</Link>
              </li>
            </ul>
          </div>
        </div> */}
      </div>
    </Main>
  );
}
